<!--
  --
  -- フライト入力コンポーネント
  --
  -->
<template>
  <v-radio-group
    v-model="decided"
    class="mt-0"
  >
    <v-radio
      :value="true"
      class="mb-6"
      style="align-items: flex-start"
    >
      <template #label>
        <div style="margin-top: 3px;">
          <div>フライトを入力</div>

          <v-row>
            <v-col cols="6">
              <v-text-field
                label="到着便"
                v-model="arrival"
                :disabled="!decided"
                hide-details
              />
            </v-col>

            <v-col cols="6">
              <v-text-field
                label="出発便"
                v-model="departure"
                :disabled="!decided"
                hide-details
              />
            </v-col>
          </v-row>
        </div>
      </template>
    </v-radio>

    <v-radio
      label="フライトは未定"
      :value="false"
    />
  </v-radio-group>
</template>

<script>
export default {
  name: 'CFlightInput',

  props: {
    flights: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    // フライトが決定しているか
    decided: true,

    // 到着便の入力値
    arrival: '',

    // 出発便の入力値
    departure: ''
  }),

  watch: {
    /**
     * フライトの決定/未定が変更された
     */
    decided (value) {
      if (value) {
        this.flights.decided = true
        this.flights.arrival = this.arrival
        this.flights.departure = this.departure
      } else {
        this.flights.decided = false
        this.flights.arrival = ''
        this.flights.departure = ''
      }
    },

    /**
     * 到着便が変更された
     */
    arrival (value) {
      if (this.decided) {
        this.flights.arrival = value
      }
    },

    /**
     * 出発便が変更された
     */
    departure (value) {
      if (this.decided) {
        this.flights.departure = value
      }
    }
  },

  /**
   * flights プロパティの内容を decided, arrival, departure に反映する
   */
  created () {
    this.decided = this.flights.decided
    this.arrival = this.flights.arrival
    this.departure = this.flights.departure
  }
}
</script>
